'use strict';

module.exports = require('./src/standalone/');



//////////////////
// WEBPACK FOOTER
// ./~/autocomplete.js/index.js
// module id = 54
// module chunks = 0 1